// generate covers crud

import client from "./client";

export function getCover (productKey, coverKey, params = {}) {
    const response = client.get("/api/covers/" + productKey + "/" + coverKey, {
        params
    });
    return response;
}

export function getCovers (productKey, params) {
    const response = client.get("/api/covers/" + productKey, { params: params });
    return response;
}

export function createCover (productKey, params) {
    const response = client.post("/api/covers/" + productKey, params);
    return response;
}

export function updateCover (productKey, coverKey, params) {
    const response = client.put("/api/covers/" + productKey + "/" + coverKey, params);
    return response;
}

export function deleteCover (productKey, coverKey) {
    const response = client.delete("/api/covers/" + productKey + "/" + coverKey);
    return response;
}


    